import React from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { nearbyPlaces } from '../mock';
import { MapPin, Compass } from 'lucide-react';

export default function Nearby() {
  const groups = nearbyPlaces.reduce((acc, p) => {
    (acc[p.category] = acc[p.category] || []).push(p);
    return acc;
  }, {});

  return (
    <div>
      <div
        className="relative h-[46vh] min-h-[340px] bg-cover bg-center"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1682848310112-be63321ce3d0?crop=entropy&cs=srgb&fm=jpg&q=85)`,
        }}
      >
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">Around Etawah</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">
            Tourist Places Nearby
          </h1>
          <p className="text-[#f7e6c2]/90 max-w-2xl mt-3 text-lg">
            Extend your safari trip with these must-visit destinations.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <Reveal>
            <SectionHeader
              center
              eyebrow="Explore More"
              title="Beyond the Safari"
              subtitle="From wetlands teeming with Sarus cranes to ancient temples and river forts – Etawah is a hidden gem for travellers."
            />
          </Reveal>

          {Object.entries(groups).map(([category, places], gi) => (
            <div key={category} className={gi > 0 ? 'mt-16' : ''}>
              <Reveal>
                <div className="flex items-center gap-3 mb-8">
                  <Compass className="text-[#b8791c]" size={22} />
                  <h3 className="font-display text-2xl md:text-3xl text-[#2b1d0e]">
                    {category}
                  </h3>
                  <div className="flex-1 h-[2px] bg-gradient-to-r from-[#b8791c] to-transparent" />
                </div>
              </Reveal>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {places.map((p, i) => (
                  <Reveal key={p.name} delay={i * 100}>
                    <div className="card-tilt bg-white rounded-lg overflow-hidden shadow-md border border-[#e6d3b0] h-full flex flex-col">
                      <div className="h-56 overflow-hidden">
                        <img
                          src={p.img}
                          alt={p.name}
                          className="img-zoom w-full h-full object-cover"
                        />
                      </div>
                      <div className="p-6 flex-1 flex flex-col">
                        <h4 className="font-display text-xl text-[#2b1d0e]">
                          {p.name}
                        </h4>
                        <div className="flex items-center gap-1.5 text-xs text-[#8b6520] mt-1 mb-3">
                          <MapPin size={12} />
                          <span>{p.distance}</span>
                        </div>
                        <p className="text-sm text-[#5c4020] leading-relaxed">
                          {p.desc}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-[#2b1d0e] text-[#f7e6c2] text-center relative overflow-hidden grain">
        <div className="container-x relative z-10">
          <Reveal>
            <span className="eyebrow text-[#f0b040]">Plan Your Trip</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-[#fff8ec] mt-3">
              Make it a Weekend Getaway
            </h2>
            <p className="text-[#c9a35c] max-w-xl mx-auto mt-3">
              Combine your Etawah Lion Safari visit with these attractions for a
              complete Uttar Pradesh experience.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
